module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_11.e1ab89ce.jpg";